export const authSelector = state => state.getIn(['firebase', 'auth']);
